import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class RequestTypeService {
    API_REQUEST_TYPE_URL = config.serverAddress + ':' + config.serverPort + '/request-type/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_REQUEST_TYPE_URL + 'all');
    }
}
